import { StarIcon } from "@heroicons/react/solid";

const StarRating = ({ rating }) => {
  const totalStars = 5;
  const fullStar = "text-yellow-400";
  const emptyStar = "text-gray-300";

  const renderStars = () => {
    const stars = [];
    let fullStars = Math.floor(rating);
    let hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < totalStars; i++) {
      if (i < fullStars) {
        stars.push(<StarIcon key={i} className={`h-5 w-5 ${fullStar}`} />);
      } else if (hasHalfStar) {
        stars.push(
          <div key={fullStars} className="relative">
            <StarIcon className="w-5 h-5 text-gray-200" />
            <div className="absolute top-0 left-0 w-1/2 h-6 overflow-hidden">
              <StarIcon className="w-5 h-5 text-yellow-400" />
            </div>
          </div>
        );
        hasHalfStar = false;
      } else {
        stars.push(<StarIcon key={i} className={`h-5 w-5 ${emptyStar}`} />);
      }
    }

    return stars;
  };

  return <div className="flex items-center">{renderStars()}</div>;
};

export default StarRating;
